const CPF_LENGTH = 11;

const isRepeatedSequence = (value: string): boolean => /^(\d)\1+$/.test(value);

const calculateDigit = (base: string, factor: number): number => {
  const sum = base
    .split("")
    .reduce((acc, digit, index) => acc + Number(digit) * (factor - index), 0);

  const result = (sum * 10) % 11;
  return result >= 10 ? 0 : result;
};

export const isValidCpf = (cpf: string): boolean => {
  if (cpf.length !== CPF_LENGTH) return false;
  if (!/^\d+$/.test(cpf)) return false;
  if (isRepeatedSequence(cpf)) return false;

  const base = cpf.slice(0, 9);

  const dv1 = calculateDigit(base, 10);
  const dv2 = calculateDigit(base + dv1, 11);

  return cpf === base + dv1 + dv2;
};
